/* eslint-disable consistent-return */
import AddressSearch, { EVENT_EDIT_ADDRESS_MANUALLY, EVENT_EDIT_ADDRESS_SEARCH } from '../../components/AddressSearch';
import CheckoutModal from '../../components/CheckoutModal';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import Manipulator from '../../utils/dom/manipulator';
import { ClassNames } from '../../utils/dom/css-classes';
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import { clearCart } from '../../api/checkout';
import AddPlayer from '../../components/AddPlayer';
import Select from '../../components/Select';
import Modal from '../../components/Modal';
import Accordion from '../../components/Accordion';
import PaymentMethodSelector from '../../components/PaymentMethodSelector';
import BodyLoader from '../../components/BodyLoader';
import intlTelInput from 'intl-tel-input';
import dayjs from 'dayjs';
import { PaymentPage } from '../../components/PaymentMethodSelector/place-order-api';
import FormGenerator from '../../components/FormGenerator';
import { id } from 'common-tags';
import SessionCheckoutSummary from '../../components/SessionCheckoutSummary';
import { EVENT_UPDATE_SESSION_DATA } from '../../components/SessionPlayersList';
import { EVENT_UPDATE_PLAYER_DATA } from '../../components/PlayerList';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

const SELECTOR_WRAPPER = '.p-checkout';
const SELECTOR_PLAYER_COUNT = '#player-count';
const SELECTOR_EDIT_BUTTON = '#edit-checkout-button';
const SELECTOR_ERROR_WRAPPER = '.p-checkout__submission_error_wrapper';
const SELECTOR_PAYMENT_SECTION = '.p-checkout__payment';
const SELECTOR_ADDRESS_SEARCH = '.p-checkout__address-details';
const SELECTOR_CHECKOUT_MODAL = '.js-checkout-modal';
const SELECTOR_ADDRESS_FORM = '.js-edit-address'; // TODO: Reuse in src/site/_includes/components/CheckoutAddressDetails/CheckoutAddressDetails.js
const SELECTOR_ADDRESS_MODAL = '.lta-modal';
const SELECTOR_ADDRESS_SEARCH_BUTTON = '.js-auto-submit';

const SELECTOR_PLAYER_DETAILS = '.p-checkout__player-details';
const SELECTOR_ADD_PLAYER_TRIGGER_BUTTON = '.js-trigger-add-player';
const SELECTOR_ADD_PLAYER_MODAL = '#add-player-modal';
const SELECTOR_ADD_PLAYER_COMPONENT = '.lta-add-player';
const SELECTOR_PLAYER_LIST = '.add-player-list';
const SELECTOR_HEALTH_CONDITION_CONTAINER = '.p-checkout__additional-Information-health-condition-container';
const SELECTOR_ADDITIONAL_INFO_TEXTAREA = '.p-checkout__additional-Information-textarea';
const SELECTOR_PLAYER_MERCHANDISE_CONTAINER = '.p-checkout__player-merchandise-size';
const SELECTOR_PLAYER_HEALTH_DESCRIPTION = '.p-checkout__additional-Information-description';
const SELECTOR_ERROR_CLASS = '.lta-text-input--error';
const SELECTOR_YOUTH_CONTAINER = '.p-checkout__youth-container';
const SELECTOR_YOUTH_SELF_CONTAINER = '.p-checkout__youth-self';
const SELECTOR_EMERGENCY_CONTACT_CONTAINER = '.p-checkout__emergency-contact';
const SELECTOR_EMERGENCY_CONTACT = '.p-checkout__emergency-contact-number';
const SELECTOR_RELATION_CONTACT = '.p-checkout__emergency-contact-relationship';
const SELECTOR_DISCOUNT_CODE = '.p-checkout__discount-code';
const SELECTOR_DISCOUNT_VALID_CONTAINER = '.p-checkout__discount-code-valid-container';
const SELECTOR_DISCOUNT_VALID_REMOVE = '.p-checkout__discount-code-valid-remove';
const SELECTOR_BOOKING_DETAILS = '.p-checkout__accordion-booking-details';
const SELECTOR_DISCOUNT_PERCENTAGE = '.p-checkout__discount-code-percentage';
const SELECTOR_DISCOUNT_TEXT = '.p-checkout__discount-code-text';
const SELECTOR_CHECKOUT_SUMMARY = '.p-checkout__summary';
const SELECTOR_CHECKOUT_SUMMARY_FORM = '.p-checkout__summary-btw-form';
const SELECTOR_BTW_CHECKOUT_SUMMARY_DETAILS = '.p-btw-checkout-summary-details';
const SELECTOR_BTW_CHECKOUT_SUMMARY_DETAILS_PLAYERNAMES = '.p-btw-summary-details-player-names';

const SELECTOR_SEARCH_ADDRESS_RESULT = '.lta-address-search--result';
const SELECTOR_SEARCH_ADDRESS_FIND = '.lta-address-search--find';
const SELECTOR_SEARCH_ADDRESS_FIND_SUGGEST = '.lta-address-search--find-suggest';
const SELECTOR_SEARCH_ADDRESS_FIND_MANUAL = '.lta-address-search--find-manual';
const SELECTOR_SUGGEST_BUTTON = '.js-auto-submit';
const SELECTOR_MANUAL_BUTTON = '.js-manual-submit';

const EVENT_ADDRESS_FORM_CHANGE = 'change';
const MODAL_HIDE_EVENT = 'hidden.lta.modal';
const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const SELECTOR_INPUT = 'input';
const SELECTOR_RADIO = 'radio';
const SELECTOR_SELECT = 'select';

const IS_INVALID_CLASS = 'is-invalid';
const IS_FOCUSED_CLASS = 'is-focused';
const HAS_ICON_CLASS = 'has-icon';

const CARD_SELECTED_CLASS = 'p-checkout__card--selected';
const SELECTOR_DISCOUNT_AMOUNT = '.p-checkout__basket-summary-discount-amount';

const DISCOUNT_CODE_NOT_VALID = 'The discount code you’ve entered is not valid';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

const IS_LOCAL = false;
const pickComparisonFields = ({ city, street, state, postCode }) =>
	[city, street, state, postCode].map((value = '') => value.trim());

export const FormTypes = {
	StepForm: 'stepForm',
	SectionForm: 'sectionForm'
};

class Checkout {
	// eslint-disable-next-line complexity
	constructor({ selectors }) {
		this.address = {};
		this.wrapper = SelectorEngine.findOne(selectors.wrapper);
		this.discountAmountValue = undefined;
		this.discountCodeDataValue = undefined;
		this.isValidPlayer = false;
		this.highestStep = undefined;
		if (this.wrapper) {
			const bodyElement = SelectorEngine.findOne('body');
			if (bodyElement) {
				const bodyLoaderInstance = BodyLoader.getOrCreateInstance(bodyElement);
				bodyLoaderInstance.shouldSkipLoader = true;
			}
			this.playerCount = SelectorEngine.findOne(selectors.playerCount, this.wrapper);
			this.paymentSection = SelectorEngine.findOne(selectors.paymentSection, this.wrapper);
			this.errorWrapper = SelectorEngine.findOne(selectors.errorWrapper, this.wrapper);
			this.modal = SelectorEngine.findOne(SELECTOR_CHECKOUT_MODAL, this.wrapper);
			this.editButton = SelectorEngine.findOne(SELECTOR_EDIT_BUTTON, this.wrapper);
			this.playerDetails = SelectorEngine.findOne(SELECTOR_PLAYER_DETAILS, this.wrapper);
			this.addressSearchElement = SelectorEngine.findOne(SELECTOR_ADDRESS_SEARCH, this.wrapper);
			if (this.addressSearchElement) {
				this.addressForm = SelectorEngine.findOne(SELECTOR_ADDRESS_FORM, this.addressSearchElement);
				this.addressModal = SelectorEngine.findOne(SELECTOR_ADDRESS_MODAL, this.addressSearchElement);
				this.addressSearchButton = SelectorEngine.findOne(SELECTOR_ADDRESS_SEARCH_BUTTON, this.addressSearchElement);
			}

			this.youthContainer = SelectorEngine.findOne(SELECTOR_YOUTH_CONTAINER, this.wrapper);
			this.discountCode = SelectorEngine.findOne(SELECTOR_DISCOUNT_CODE, this.wrapper);
			this.checkoutErrorContainer = SelectorEngine.find('.p-checkout__error-container', this.wrapper);
			if (this.discountCode) {
				this.discountInput = SelectorEngine.findOne('.p-checkout__discount-code-input', this.discountCode);
				this.discountInputElement = SelectorEngine.findOne('input', this.discountInput);
				this.discountApplyButton = SelectorEngine.findOne('.p-checkout__discount-code-apply-button', this.discountCode);
			}
			this.discountValidContainer = SelectorEngine.findOne(SELECTOR_DISCOUNT_VALID_CONTAINER, this.wrapper);
			if (this.discountValidContainer) {
				this.discountValidRemoveButton = SelectorEngine.findOne(
					SELECTOR_DISCOUNT_VALID_REMOVE,
					this.discountValidContainer
				);
				this.discountPercentage = SelectorEngine.findOne(SELECTOR_DISCOUNT_PERCENTAGE, this.discountValidContainer);
				this.discountCodeText = SelectorEngine.findOne(SELECTOR_DISCOUNT_TEXT, this.discountValidContainer);
			}
			if (this.playerDetails) {
				this.addPlayerTriggerButton = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_TRIGGER_BUTTON, this.playerDetails);
				this.addPlayerComponent = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_COMPONENT, this.playerDetails);
				this.playerList = SelectorEngine.findOne(SELECTOR_PLAYER_LIST, this.playerDetails);
				this.addPlayerModal = new Modal(SelectorEngine.findOne(SELECTOR_ADD_PLAYER_MODAL, this.playerDetails));
			}

			this.healthConditionContainer = SelectorEngine.findOne(SELECTOR_HEALTH_CONDITION_CONTAINER, this.wrapper);
			this.additionalTextarea = SelectorEngine.findOne(SELECTOR_ADDITIONAL_INFO_TEXTAREA, this.wrapper);
			if (this.additionalTextarea) {
				this.additionalTextareaDescription = SelectorEngine.findOne(
					SELECTOR_PLAYER_HEALTH_DESCRIPTION,
					this.additionalTextarea
				);
				this.additionalTextareaElement = SelectorEngine.findOne('textarea', this.additionalTextarea);
			}
			if (this.healthConditionContainer) {
				this.healthConditionButtons = SelectorEngine.find(
					'input[name="health-condition"]',
					this.healthConditionContainer
				);
			}
			this.playerMerchandiseSize = SelectorEngine.findOne(SELECTOR_PLAYER_MERCHANDISE_CONTAINER, this.wrapper);
			if (this.playerMerchandiseSize) {
				this.playerMerchandiseElement = SelectorEngine.findOne('.js-lta-select', this.playerMerchandiseSize);
				this.playerMerchandiseSizeSelect =
					Select.getInstance(this.playerMerchandiseElement) || new Select(this.playerMerchandiseElement);
			}
			this.payementSelector = SelectorEngine.findOne('.p-checkout__payment .js-lta-payment', this.wrapper);
			this.youthSelfContainer = SelectorEngine.findOne(SELECTOR_YOUTH_SELF_CONTAINER, this.wrapper);

			if (this.payementSelector) {
				this.abtoElement = SelectorEngine.findOne('.payment-method-abto', this.payementSelector);
			}

			this.emergencyContactContainer = SelectorEngine.findOne(SELECTOR_EMERGENCY_CONTACT_CONTAINER, this.wrapper);
			if (this.emergencyContactContainer) {
				this.emergencyContact = SelectorEngine.findOne(SELECTOR_EMERGENCY_CONTACT, this.emergencyContactContainer);
				this.emergencyContactValue = SelectorEngine.findOne(SELECTOR_INPUT, this.emergencyContact);
				this.countryCodeInput = intlTelInput(this.emergencyContactValue, {
					preferredCountries: ['gb'],
					separateDialCode: true
				});
			}
			this.relationShipContainer = SelectorEngine.findOne(SELECTOR_RELATION_CONTACT, this.wrapper);
			if (this.relationShipContainer) {
				this.relationShipElement = SelectorEngine.findOne('.js-lta-select', this.relationShipContainer);
				this.relationShipSelect = Select.getInstance(this.relationShipElement) || new Select(this.relationShipElement);
			}
			this.bookingDetails = SelectorEngine.findOne(SELECTOR_BOOKING_DETAILS, this.wrapper);
			this.checkoutUrl = Manipulator.getDataAttribute(this.wrapper, 'checkoutUrl');
			if (this.payementSelector) {
				this.termsConditionElement = SelectorEngine.findOne('.terms-and-conditions-selection', this.payementSelector);
				this.submitButton = SelectorEngine.findOne('#payment-btn', this.payementSelector);
				if (this.termsConditionElement) {
					this.submitButton.setAttribute('disabled', 'true');
					EventHandler.on(this.termsConditionElement, 'click', (event) => {
						if (event.target.checked) {
							this.submitButton.removeAttribute('disabled');
						} else {
							this.submitButton.setAttribute('disabled', 'true');
						}
					});
				}
				this.providerName = Manipulator.getDataAttribute(this.payementSelector, 'provider');

				if (this.paymentSection) {
					this.paymentMethods = SelectorEngine.findOne('.payment-method-card', this.paymentSection);
					this.savedCardsDetailsCheckbox = SelectorEngine.findOne('.save-cards-details', this.paymentSection);
					this.savedCardsDetails = SelectorEngine.findOne('.saved-cards-details', this.paymentSection);
					this.savedCardsList = SelectorEngine.findOne('.saved-cards-list', this.paymentSection);
					if (this.savedCardsDetails) {
						this.addAnotherCardButton = SelectorEngine.findOne('.add-another-card--button', this.savedCardsDetails);
						EventHandler.on(this.addAnotherCardButton, CLICK_EVENT, () => {
							this.isFromSavedCard = false;
							this.paymentMethods.classList.remove(HIDDEN_CLASS);
							this.savedCardsDetailsCheckbox.classList.remove(HIDDEN_CLASS);
							this.savedCardsDetails.classList.add(HIDDEN_CLASS);
						});
					}
				}
			}
			this.isFromSavedCard = false;

			const page = window?.lta?.checkout?.screen;
			const provider = window.lta.checkout.paymentSource;
			const courtPrice = provider == "imin" ? window.lta.imin.basket.totalCost : window.lta.clubspark.basket.totalCost;
			const totalCost =
				window?.lta?.checkout?.totalCost === undefined
					? courtPrice
					: window?.lta?.checkout?.totalCost;
			const internalPaymentVerification = [PaymentPage.LICENCE_RENEWAL, PaymentPage.ACCREDITATION_RENEWAL].includes(
				page
			);

			if (totalCost && totalCost > 0 && internalPaymentVerification) {
				this.fetchCustomer();
			}

			this.checkoutSummaryElement = SelectorEngine.findOne(SELECTOR_CHECKOUT_SUMMARY, this.wrapper);
			this.checkoutBTWFormElement = SelectorEngine.findOne(SELECTOR_CHECKOUT_SUMMARY_FORM, this.checkoutSummaryElement);
			this.fetchBTWStepsDataAPIUrl = Manipulator.getDataAttribute(this.wrapper, 'checkout-url-events');
			if (this.checkoutBTWFormElement) {
				this.fetchBTWStepsData();
			} else {
				this.init();
			}
		}
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initBTWForm(_stepsData);
		}
	}

	get playersData() {
		return this._playersData;
	}
	set playersData(data) {
		this._playersData = data;
		if (this._playersData.length > 0) {
			this.renderPlayerList();
		}
	}

	get savedCardsData() {
		return this._savedCardsData;
	}
	set savedCardsData(data) {
		this._savedCardsData = data;
		if (this._savedCardsData.length > 0) {
			this.renderSaveCards();
		}
	}

	init() {
		CheckoutModal.getOrCreateInstance(this.modal);
		if (this.addPlayerComponent) {
			this.addPlayer = new AddPlayer(this.addPlayerComponent);
			this.addPlayer.onExitClick(() => {
				this.addPlayerModal.hide();
			});
			this.addPlayer.onSubmitClick((playerObject) => {
				this.addPlayerModal.hide();
				this.fetchPlayersList(playerObject);
			});
			this.fetchPlayersList();
		}

		if (
			this.payementSelector &&
			(this.playerDetails || this.youthSelfContainer || this.abtoElement || this.savedCardsDetailsCheckbox)
		) {
			this.paymentMethodSelector = PaymentMethodSelector.getOrCreateInstance(this.payementSelector);
			// eslint-disable-next-line complexity
			this.paymentMethodSelector.validateOnCheckout = () => {
				let playerIdValue,
					playerSize,
					emergencyContactValue,
					relationShipContact,
					playerhealthCondition,
					playerhealthConditionDescription,
					savedCardIdValue;
				let hasPlayerData = false;
				let hasSavedCardData = false;
				let hasPlayerMerchandiseData = false;
				let hasYouthSelfContainer = false;
				let hasHealthContainerData = false;
				let hasRelationShipContainerData = false;
				let hasAddressContainerData = false;
				let youthCheckoutConfig = {
					discountAmount: this.discountAmountValue,
					discountCode: this.discountCodeDataValue
				};

				const walletPaymentRadioButton = SelectorEngine.findOne('#wallet-input', this.payementSelector);
				const isWalletSelected = walletPaymentRadioButton?.checked;

				const cardPaymentRadioButton = SelectorEngine.findOne('#card-input', this.payementSelector);
				const isCardSelected = cardPaymentRadioButton?.checked;

				if (this.savedCardsDetailsCheckbox) {
					this.paymentMethodSelector.stripeCustomerRef = this.stripeCustomerRef;

					// uncomment when we introduce save card feature for coaches and officials.
					// if (isWalletSelected) {
					// 	this.savedCardsDetailsCheckbox?.classList.add(HIDDEN_CLASS);
					// } else if (isCardSelected) {
					// 	this.savedCardsDetailsCheckbox?.classList.remove(HIDDEN_CLASS);
					// }
				}

				if (this.totalCost) {
					youthCheckoutConfig = {
						...youthCheckoutConfig,
						totalCost: this.totalCost
					};
				}
				if (this.abtoElement) {
					this.abtoElementCheckbox = SelectorEngine.findOne('#abtoCheck', this.abtoElement);
					this.paymentMethodSelector.abto = this.abtoElementCheckbox?.checked;
				}

				// uncomment when we introduce save card feature for coaches and officials.
				// if (this.savedCardsDetailsCheckbox && isCardSelected) {
				// 	this.savedCardsDetailsCheckboxElement = SelectorEngine.findOne(
				// 		'#SaveCardDetails',
				// 		this.savedCardsDetailsCheckbox
				// 	);
				// 	this.paymentMethodSelector.isSaveCard = this.savedCardsDetailsCheckboxElement?.checked;
				// 	this.paymentMethodSelector.stripeCustomerRef = this.stripeCustomerRef;
				// }

				if (this.addressSearchElement) {
					const isValidAddressValue = this.isValidAddress(this.addressSearchElement);
					if (isValidAddressValue) {
						hasAddressContainerData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							address: this.address
						};
					}
				}

				if (this.playerDetails) {
					playerIdValue = this.validInputValue(this.formElementsList?.playerList);
					const playerObject = this.playersData.find((player) => player.id === playerIdValue);
					if (playerIdValue) {
						hasPlayerData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							playerId: playerIdValue,
							emergencyContactFomPlayer: `${playerObject.contactNo}`,
							name: `${playerObject.firstName} ${playerObject.lastName}`
						};
					}
				}

				if (this.isFromSavedCard && !isWalletSelected) {
					savedCardIdValue = this.validInputValue(this.formElementsList?.savedCardsList);
					if (savedCardIdValue) {
						hasSavedCardData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							paymentId: savedCardIdValue
						};
					}
				}

				if (this.playerMerchandiseSize) {
					playerSize = this.validInputValue(this.formElementsList.playerMerchandiseSize);
					if (playerSize) {
						hasPlayerMerchandiseData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							shirtSize: playerSize
						};
					}
				}

				if (this.youthSelfContainer) {
					emergencyContactValue = this.validInputValue(this.formElementsList?.emergencyContact);
					if (emergencyContactValue) {
						hasYouthSelfContainer = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							emergencyContactNumber: `+${
								this.countryCodeInput.getSelectedCountryData().dialCode
							}${emergencyContactValue}`
						};
					}
				}

				if (this.relationShipContainer) {
					relationShipContact = this.relationShipSelect._selectNativeElement.value;
					if (relationShipContact) {
						hasRelationShipContainerData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							relationshipContact: relationShipContact
						};
					}
				}

				if (this.healthConditionContainer) {
					playerhealthCondition = this.validInputValue(this.formElementsList.healthCondition);
					playerhealthConditionDescription =
						playerhealthCondition === 'yes'
							? this.validInputValue(this.formElementsList.healthConditionDescription)
							: '';
					if (playerhealthCondition === 'no' || (playerhealthCondition === 'yes' && playerhealthConditionDescription)) {
						hasHealthContainerData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							isPlayerHealthCondition: playerhealthCondition,
							specialRequirements: playerhealthConditionDescription
						};
					}
				}

				return (!this.playerDetails || hasPlayerData) &&
					(!this.playerMerchandiseSize || hasPlayerMerchandiseData) &&
					(!this.youthSelfContainer || hasYouthSelfContainer) &&
					(!this.healthConditionContainer || hasHealthContainerData) &&
					(!this.addressSearchElement || hasAddressContainerData) &&
					(!this.relationShipContainer || hasRelationShipContainerData) &&
					(!(this.isFromSavedCard && !isWalletSelected) || hasSavedCardData)
					? youthCheckoutConfig
					: false;
			};
		}
		if (this.youthSelfContainer) {
			this.formElementsList = {
				...this.formElementsList,
				emergencyContact: {
					element: this.emergencyContact,
					formElement: this.emergencyContactValue,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter a emergency contact number',
					hasIcon: false
				}
			};
		}
		if (this.discountCode) {
			this.formElementsList = {
				...this.formElementsList,
				discountCode: {
					element: this.discountInput,
					formElement: this.discountInputElement,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter discount code',
					hasIcon: false
				}
			};
			EventHandler.on(this.discountApplyButton, CLICK_EVENT, () => {
				const discountCodeValue = this.validInputValue(this.formElementsList.discountCode);
				if (discountCodeValue) {
					this.discountApplyRemove(discountCodeValue);
				}
			});
		}
		if (this.discountValidContainer) {
			EventHandler.on(this.discountValidRemoveButton, CLICK_EVENT, () => {
				this.discountValidContainer.classList.add(HIDDEN_CLASS);
				this.discountCode.classList.remove(HIDDEN_CLASS);
				this.discountInputElement.value = '';
				this.discountApplyRemove('');
			});
		}
		if (this.healthConditionContainer) {
			this.formElementsList = {
				...this.formElementsList,
				healthCondition: {
					element: this.healthConditionContainer,
					formElement: this.healthConditionButtons,
					inputType: SELECTOR_RADIO,
					errorMessage: 'Please select one option',
					hasIcon: false
				},
				healthConditionDescription: {
					element: this.additionalTextareaDescription,
					formElement: this.additionalTextareaElement,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter details here',
					hasIcon: false
				}
			};
			for (const radioButton of this.healthConditionButtons) {
				EventHandler.on(radioButton, CLICK_EVENT, () => {
					const healthValue = this.validInputValue(this.formElementsList.healthCondition);
					if (healthValue === 'yes') {
						this.additionalTextarea.classList.remove(HIDDEN_CLASS);
					} else {
						this.additionalTextarea.classList.add(HIDDEN_CLASS);
					}
				});
			}
		}

		if (this.playerMerchandiseSize) {
			this.formElementsList = {
				...this.formElementsList,
				playerMerchandiseSize: {
					element: this.playerMerchandiseSize,
					formElement: this.playerMerchandiseSizeSelect._selectNativeElement,
					inputType: SELECTOR_SELECT,
					errorMessage: 'Please select size',
					hasIcon: false
				}
			};
			EventHandler.on(this.playerMerchandiseSizeSelect._selectNativeElement, 'change', () => {
				this.validInputValue(this.formElementsList.playerMerchandiseSize);
			});
		}

		if (this.addPlayerTriggerButton) {
			EventHandler.on(this.addPlayerTriggerButton, CLICK_EVENT, () => {
				this.addPlayerModal.show();
			});
		}

		EventHandler.on(this.addressModal, MODAL_HIDE_EVENT, () => {
			this.addressSearchButton.disabled = false;
		});

		EventHandler.on(this.addressSearchElement, EVENT_EDIT_ADDRESS_MANUALLY, () => {
			this.displayPaymentSection(false);
			if (this.playerCount) {
				this.displayPlayerCount(false);
			}
		});

		EventHandler.on(this.addressSearchElement, EVENT_EDIT_ADDRESS_SEARCH, () => {
			this.displayPaymentSection(false);
			if (this.playerCount) {
				this.displayPlayerCount(false);
			}
		});

		EventHandler.on(this.editButton, Events.Click, () => {
			const { bookingToken } = window.lta[this.providerName].basket;
			clearCart(bookingToken);
		});
		// TODO: This shouldn't be listening to an event defined outside of this file without importing the reference.
		EventHandler.on(this.addressForm, EVENT_ADDRESS_FORM_CHANGE, (event) => {
			const address = event?.detail?.values;
			if (address) {
				if (this.playerCount) {
					this.displayPlayerCount(true);
				}
				if (this.youthSelfContainer) {
					this.youthContainer.classList.remove(HIDDEN_CLASS);
				}

				if (!this.playerDetails || this.isValidPlayer) {
					this.displayPaymentSection(true);
				}

				if (event.detail.existing) {
					this.address = address;
				} else if (!this.matchAddressValues(this.address, address)) {
					this.submitForm(event);
				}
			}
		});
	}

	async fetchBTWStepsData() {
		startLoadingAnimation();
		try {
			const url = this.fetchBTWStepsDataAPIUrl;
			const response = await Request.post(
				url,
				window?.lta?.checkout?.extraParams,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.highestStep = 0;
				for (const element of Steps) {
					if (element.step > this.highestStep) {
						this.highestStep = element.step;
					}
				}
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				stopLoadingAnimation();
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			console.log('error', error);

			if (error.hasError) {
				console.log('Error : ', error);
			}
		} finally {
			stopLoadingAnimation();
		}
	}

	initBTWForm(stepsData) {
		this.paymentMethodSelector = PaymentMethodSelector.getOrCreateInstance(this.payementSelector);
		this.checkoutEventsFormGenerator = new FormGenerator(this.checkoutBTWFormElement, {
			questions: stepsData,
			totalSteps: this.highestStep,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			submitButton: {
				title: 'Confirm booking'
			}
		});

		this.paymentMethodSelector.onCheckoutError((error) => {
			//TODO: SAMLE ERROR DATA FOR CHECKOUT TO REDIRECT PARTICULAR STEP AND QUESTION
			const { errorData } = JSON.parse(error.errorData);

			this.checkoutEventsFormGenerator?.reRenderForm(errorData);
		});

		this.checkoutEventsFormGenerator.onSubmit((answer) => {
			// TODO: Prepare payload here before passing.
			this.paymentMethodSelector.payload = this.prepareRequestObject(answer);

			if (this.paymentMethodSelector.payload?.['sessionplayers']) {
				this.paymentMethodSelector.payload.sessionplayers = Object.keys(
					this.paymentMethodSelector.payload?.['sessionplayers']
				).map((key) => {
					return {
						sessionId: key,
						players: this.paymentMethodSelector.payload?.['sessionplayers']?.[key]
					};
				});
			}

			SelectorEngine.findOne('#payment-btn')?.click();
		});

		EventHandler.on(SelectorEngine.findOne('body'), EVENT_UPDATE_SESSION_DATA, (data) => {
			if (this.sessionDetails) {
				this.sessionDetails.map((_sessionDetails) => {
					_sessionDetails.updateSessionCheckout(data?.sessions);
				});
			}
		});

		const uniqueNames = new Set();
		const step1Names = [];
		const otherStepNames = [];

		// Collect name of default user
		stepsData
			.filter((step) => step.id === 1)
			.flatMap((step) => step.supportingProps?.players?.map((player) => player.name) || [])
			.forEach((name) => {
				step1Names.push(name);
				uniqueNames.add(name);
			});

		// Collect names from associated children and additional players
		stepsData
			.filter((step) => step.id !== 1)
			.flatMap((step) => step.supportingProps?.players?.map((player) => player.name) || [])
			.forEach((name) => {
				if (!step1Names.includes(name)) {
					otherStepNames.push(name);
				} else if (!uniqueNames.has(name)) {
					otherStepNames.push(name);
					uniqueNames.add(name);
				}
			});

		const playerNamesList = step1Names.concat(otherStepNames);
		const playerNamesCSV = playerNamesList.join(', ');

		this.playerNameElements = SelectorEngine.find(SELECTOR_BTW_CHECKOUT_SUMMARY_DETAILS_PLAYERNAMES, this.wrapper);

		if (this.playerNameElements) {
			this.playerNameElements.map((element) => {
				element.innerHTML = `Players: ${playerNamesCSV}`;
			});
		}

		EventHandler.on(SelectorEngine.findOne('body'), EVENT_UPDATE_PLAYER_DATA, (data) => {
			if (this.playerNameElements) {
				this.playerNameElements.map((_playerElement) => {
					const currentContent = _playerElement.innerHTML;
					_playerElement.innerHTML = currentContent + ', ' + data.updatedData;
				});
			}
		});

		const filteredSessionDatas = stepsData.filter((step) => step.fieldName === 'sessionplayers');
		const sessionsData = filteredSessionDatas[0]?.supportingProps?.sessions;
		this.summaryElements = SelectorEngine.find(SELECTOR_BTW_CHECKOUT_SUMMARY_DETAILS, this.wrapper);

		this.sessionDetails = [];
		if (this.summaryElements) {
			this.summaryElements.map((element) => {
				this.sessionDetails.push(new SessionCheckoutSummary(element, { data: sessionsData }, ''));
			});
		}
	}

	prepareRequestObject(stepsAnswers) {
		let answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				answerList = {
					...answerList,
					...formatObject
				};
			}
		}
		return answerList;
	}

	discountApplyRemove(discountCodeValue) {
		if (this.playerDetails) {
			const playerIdValue = this.validInputValue(this.formElementsList?.playerList);
			const playerObject = this.playersData.find((player) => player.id === playerIdValue);
			this.checkoutValidator(true, discountCodeValue, playerObject);
		} else {
			this.checkoutValidator(true, discountCodeValue);
		}
	}
	isValidAddress(element) {
		this.addressResult = SelectorEngine.findOne(SELECTOR_SEARCH_ADDRESS_RESULT, element);
		this.addressSearchFind = SelectorEngine.findOne(SELECTOR_SEARCH_ADDRESS_FIND, element);
		if (this.addressSearchFind) {
			this.addressSearchFindSuggest = SelectorEngine.findOne(
				SELECTOR_SEARCH_ADDRESS_FIND_SUGGEST,
				this.addressSearchFind
			);
			this.addressSearchFindManual = SelectorEngine.findOne(
				SELECTOR_SEARCH_ADDRESS_FIND_MANUAL,
				this.addressSearchFind
			);
		}
		let isAddressAvailable = true;
		if (this.addressResult.classList.contains(HIDDEN_CLASS)) {
			isAddressAvailable = false;
			if (this.addressSearchFind) {
				if (!this.addressSearchFindSuggest.classList.contains(HIDDEN_CLASS)) {
					const suggestFormButton = SelectorEngine.findOne(SELECTOR_SUGGEST_BUTTON, this.addressSearchFindSuggest);
					suggestFormButton.click();
				}

				if (!this.addressSearchFindManual.classList.contains(HIDDEN_CLASS)) {
					const manualFormButton = SelectorEngine.findOne(SELECTOR_MANUAL_BUTTON, this.addressSearchFindManual);
					manualFormButton.click();
				}
			}
		}
		return isAddressAvailable;
	}
	// eslint-disable-next-line complexity
	async checkoutValidator(isCallFromDiscount, discountValue, playerObject = {}) {
		try {
			const url = this.checkoutUrl;
			const dataObject = {
				userToken: window.lta[this.providerName].user.token,
				discountCode: discountValue,
				playerId: playerObject.id,
				playerName: `${playerObject.firstName} ${playerObject.lastName}`,
				dateOfBirth: playerObject.dateOfBirth,
				playerGender: playerObject.gender,
				emergencyContactFomPlayer: `${playerObject.contactNo}`
			};
			const response = await Request.get(url, dataObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { success, error, checkOutAccordianHtml, discountPercent, checkOutErrorHtml, discountAmount, totalCost } =
				response;
			if (success) {
				this.bookingDetails.innerHTML = checkOutAccordianHtml;
				this.registerAccordion();
				this.totalCost = totalCost;
				if (!error.showDiscountInvalidError && isCallFromDiscount) {
					if (discountValue !== '') {
						this.discountValidContainer.classList.remove(HIDDEN_CLASS);
						this.discountCode.classList.add(HIDDEN_CLASS);

						this.discountPercentage.innerHTML = Number.parseInt(discountPercent, 10);
						this.discountCodeText.innerHTML = discountValue.toString().toUpperCase();
						this.discountInputElement.value = '';
					}

					this.discountCodeDataValue = discountValue.toString();
					const discountAmountData = SelectorEngine.findOne(SELECTOR_DISCOUNT_AMOUNT, this.wrapper);
					if (discountAmountData) {
						const discountAmountHTMLValue = discountAmountData.innerHTML;
						if (discountAmountHTMLValue) {
							this.discountAmountValue = discountAmount;
						}
					}
				} else {
					this.isValidPlayer = true;
					this.youthContainer.classList.remove(HIDDEN_CLASS);
					this.displayPaymentSection(true);
				}
			} else {
				if (!isCallFromDiscount) {
					this.isValidPlayer = false;
					this.youthContainer.classList.add(HIDDEN_CLASS);
					this.displayPaymentSection(false);
				}
				if (error.showDiscountInvalidError && isCallFromDiscount) {
					this.discountValidContainer.classList.add(HIDDEN_CLASS);
					this.discountCode.classList.remove(HIDDEN_CLASS);

					this.addInvalidClasses(this.discountInput, false);
					const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, this.discountInput);
					errorElement.innerHTML = DISCOUNT_CODE_NOT_VALID;
				}
				if (error.showAgeValidationError && !isCallFromDiscount) {
					this.addInvalidClasses(this.playerList, false);
					const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, this.playerList);
					errorElement.innerHTML = error?.ageValidationMessage;
				}
				if (error.isRedirectUser && !isCallFromDiscount) {
					window.location.href = error.redirectUrl;
				}
				if (!isCallFromDiscount && checkOutErrorHtml) {
					for (const container of this.checkoutErrorContainer) {
						container.innerHTML = checkOutErrorHtml;
					}
				}
			}
		} catch (error) {
			if (!isCallFromDiscount) {
				this.isValidPlayer = false;
				this.youthContainer.classList.add(HIDDEN_CLASS);
				this.displayPaymentSection(false);
			}
			if (error.hasError) {
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		}
	}
	registerAccordion() {
		const accordions = SelectorEngine.find('.lta-accordion', this.bookingDetails);
		for (const accordion of accordions) {
			Accordion.getOrCreateInstance(accordion);
		}
	}
	validInputValue(elementObject) {
		let formElementValue;
		switch (elementObject.inputType) {
			case SELECTOR_INPUT: {
				formElementValue = elementObject.formElement.value;

				break;
			}
			case SELECTOR_RADIO: {
				for (const radioButton of elementObject.formElement) {
					if (radioButton.checked) {
						formElementValue = radioButton.value;
					}
				}

				break;
			}
			case SELECTOR_SELECT: {
				formElementValue = elementObject.formElement.value;

				break;
			}
			// No default
		}
		const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, elementObject.element);
		if (!formElementValue) {
			this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
			errorElement.innerHTML = elementObject.errorMessage;
			return '';
		} else {
			this.removeInvalidClasses(elementObject.element);
			errorElement.innerHTML = '';
			return formElementValue;
		}
	}
	addInvalidClasses(element, hasIcon) {
		element.classList.add(IS_INVALID_CLASS);
		element.classList.add(IS_FOCUSED_CLASS);
		if (hasIcon) {
			element.classList.add(HAS_ICON_CLASS);
		}
	}
	removeInvalidClasses(element) {
		element.classList.remove(IS_INVALID_CLASS);
		element.classList.remove(IS_FOCUSED_CLASS);
		element.classList.remove(HAS_ICON_CLASS);
	}
	async fetchPlayersList(selectedPlayerID) {
		startLoadingAnimation();
		try {
			const url = `/api/player/getplayers`;
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { playerDetails, error } = response;
			this.selectedPlayerDataID = selectedPlayerID ? selectedPlayerID.id : undefined;
			this.playersData = [...playerDetails];

			if (!!error?.hasError) {
				stopLoadingAnimation();
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				stopLoadingAnimation();
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		}
	}

	async fetchCustomer() {
		try {
			const url = `/api/payments/customer`;
			const response = await Request.post(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { RegisteredCards, StripeCustomerRef } = response;
			this.registeredCards = [...RegisteredCards];
			this.stripeCustomerRef = StripeCustomerRef;
			// These need to uncommented when we introduce the feature save card details. At present this feature is not implemented completely and breaking on license renewal pages when we get registered card details from saleforce.
			// if (this.registeredCards?.length > 0) {
			// 	this.isFromSavedCard = true;
			// 	this.paymentMethods.classList.add(HIDDEN_CLASS);
			// 	this.savedCardsDetailsCheckbox?.classList.add(HIDDEN_CLASS);
			// 	this.savedCardsDetails.classList.remove(HIDDEN_CLASS);
			// 	this.savedCardsData = this.registeredCards;
			// }
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	buttonClassToggle() {
		this.playerCards = SelectorEngine.find('.p-checkout__player-details-card', this.playerList);
		for (const card of this.playerCards) {
			EventHandler.on(card, CLICK_EVENT, this.selectCard.bind(this));
		}
		if (this.playerCards?.length > 0) {
			this.addPlayerTriggerButton.classList.remove('lta-btn--primary');
			this.addPlayerTriggerButton.classList.add('lta-btn--link');
			this.addPlayerTriggerButton.classList.add('is-list');
		} else {
			this.addPlayerTriggerButton.classList.add('lta-btn--primary');
			this.addPlayerTriggerButton.classList.remove('lta-btn--link');
			this.addPlayerTriggerButton.classList.remove('is-list');
		}
	}
	selectCard(event) {
		const cardCheckBox = SelectorEngine.findOne('input[type="radio"]', event.currentTarget);
		cardCheckBox.click();
	}

	addClassSelected(event, cards) {
		for (const card of cards) {
			if (card === event.target.parentElement) {
				card.classList.add(CARD_SELECTED_CLASS);
			} else {
				card.classList.remove(CARD_SELECTED_CLASS);
			}
		}
	}

	removePlayerCard() {
		if (!this.playerCards) {
			return;
		}
		for (const card of this.playerCards) {
			card.remove();
		}
	}

	renderPlayerList() {
		this.removePlayerCard(); // Removed old cards when re-renders the new one.
		this.playerList.innerHTML += this.playersData.map((data) => this.renderPlayerCard(data)).join('');
		this.buttonClassToggle();
		this.playerListButtons = SelectorEngine.find('input[name="player-details"]', this.playerList);
		if (this.playerDetails) {
			this.formElementsList = {
				...this.formElementsList,
				playerList: {
					element: this.playerList,
					formElement: this.playerListButtons,
					inputType: SELECTOR_RADIO,
					errorMessage: 'Please select one player option',
					hasIcon: false
				}
			};
		}
		if (this.playerListButtons) {
			for (const radioButton of this.playerListButtons) {
				EventHandler.on(radioButton, CLICK_EVENT, this.playerCardClickHandler.bind(this));
				if (radioButton.checked) {
					radioButton.click();
				}
			}
		}
	}

	playerCardClickHandler(event) {
		event.stopPropagation();
		this.addClassSelected(event, this.playerCards);
		this.validInputValue(this.formElementsList.playerList);
		const playerObject = this.playersData.find((player) => player.id === event.target.value);
		this.checkoutValidator(false, '', playerObject);
		if (playerObject && this.playerMerchandiseSize && playerObject.address) {
			this.changeAddressOnPlayerSelect(playerObject.address);
		}
	}

	changeAddressOnPlayerSelect(playerObjectAddress) {
		this.address = {
			street: playerObjectAddress?.streetAddress,
			city: playerObjectAddress?.addressLocality,
			state: playerObjectAddress?.addressRegion,
			postCode: playerObjectAddress?.postalCode
		};
		const playerMerchandiseAddress = SelectorEngine.findOne(
			'.js-retrive-address',
			this.playerMerchandiseSize.parentElement
		);
		const addressSearchObject = AddressSearch.getInstance(playerMerchandiseAddress);
		addressSearchObject.disbaleFocus = true;
		addressSearchObject.populateManualForm(this.address, false);
	}

	getAge(dateString) {
		const dateObject = dayjs(new Date());
		return dateObject.diff(dayjs(dateString), 'year');
	}

	renderPlayerCard(playerData) {
		return `
		<div class="p-checkout__player-details-card ${
			this.selectedPlayerDataID === playerData.id ? CARD_SELECTED_CLASS : ''
		} lta-form-check lta-form-check u-hstack g-col-12 g-col-md-6 u-h-100 u-py-1">
			<input
				class="lta-form-check-input u-mr-2"
				role="radio"
				type="radio"
				name="player-details"
				value="${playerData.id}"
				aria-label=""
				data-player-id="${playerData.id}" 
				${this.selectedPlayerDataID === playerData.id ? 'checked' : ''}/>
					<div class="p-checkout__player-details-record u-bg-background-blue u-px-3 u-py-2 u-rounded u-h-100">
						<div class="u-caption1 u-text-grey-lta">${playerData.firstName} ${playerData.lastName}</div>
						<div class="u-body1 u-text-grey-lta">Age: ${this.getAge(playerData.dateOfBirth)}</div>
						<div class="u-body1 u-text-grey-lta">${playerData.gender}</div>
						<div class="u-body1 u-text-grey-lta u-hidden">Emergency contact:${playerData.contactNo}</div>
					</div>
			</div>`;
	}

	renderSaveCards() {
		this.savedCardsList.innerHTML += this.savedCardsData.map((data) => this.renderSavedCard(data)).join('');
		this.buttonClassToggleSavedCard();
		this.savedCardListButtons = SelectorEngine.find('input[name="saved-card-details"]', this.savedCardsList);
		if (this.savedCardsList) {
			this.formElementsList = {
				...this.formElementsList,
				savedCardsList: {
					element: this.savedCardsList,
					formElement: this.savedCardListButtons,
					inputType: SELECTOR_RADIO,
					errorMessage: 'Please select one saved card option',
					hasIcon: false
				}
			};
		}
		if (this.savedCardListButtons) {
			for (const radioButton of this.savedCardListButtons) {
				EventHandler.on(radioButton, CLICK_EVENT, this.savedCardClickHandler.bind(this));
				if (radioButton.checked) {
					radioButton.click();
				}
			}
		}
	}

	buttonClassToggleSavedCard() {
		this.savedCards = SelectorEngine.find('.p-checkout__saved-card-details', this.playerList);
		for (const card of this.savedCards) {
			EventHandler.on(card, CLICK_EVENT, this.selectCard.bind(this));
		}
	}

	savedCardClickHandler(event) {
		event.stopPropagation();
		this.addClassSelected(event, this.savedCards);
		this.validInputValue(this.formElementsList.savedCardsList);
	}

	renderSavedCard(savedCardData) {
		return `
		<div class="p-checkout__saved-card-details ${
			this.selectedPlayerDataID === savedCardData.CardTokenId ? CARD_SELECTED_CLASS : ''
		} lta-form-check lta-form-check u-hstack g-col-12 g-col-md-6 u-h-100 u-py-1">
			<input
				class="lta-form-check-input u-mr-2"
				role="radio"
				type="radio"
				name="saved-card-details"
				value="${savedCardData.CardTokenId}"
				aria-label=""
				data-player-id="${savedCardData.CardTokenId}" 
				${this.selectedPlayerDataID === savedCardData.CardTokenId ? 'checked' : ''}/>
					<div class="p-checkout__saved-card-details-record u-bg-background-blue u-px-3 u-py-2 u-rounded u-h-100">
						<div class="u-caption2 u-text-grey-lta">**** **** **** ${savedCardData?.LastFour}</div>
						<div class="u-caption2 u-text-grey-lta">Exp: ${savedCardData?.ExpiryMonth}/${savedCardData?.ExpiryYear}</div>
						<div class="u-caption2 u-text-grey-lta">${savedCardData.Name}</div>
					</div>
			</div>`;
	}

	matchAddressValues(address, newAddress) {
		if (!address || !newAddress) {
			return false;
		}

		const addressFields = pickComparisonFields(address);
		return pickComparisonFields(newAddress).every((newValue, index) => newValue === addressFields[index]);
	}

	displayPaymentSection(shouldShow) {
		this.paymentSection.classList.toggle(ClassNames.Hidden, !shouldShow);
	}

	displayPlayerCount(shouldShow) {
		this.playerCount.classList.toggle(ClassNames.Hidden, !shouldShow);
	}

	async submitForm(event) {
		const { target } = event.currentTarget.dataset;
		const formData = Object.fromEntries(new FormData(this.addressForm).entries());
		try {
			const submitted = await Request.post('/api/account/personal', {
				address: formData
			});
			this.address = formData;

			if (submitted && target) {
				const rootUrl = window.location.origin;
				window.location.href = `${rootUrl}${target}`;
			}
		} catch {
			if (this.errorWrapper) {
				this.errorWrapper.classList.remove(ClassNames.Hidden);
			}
		}
	}
}
const checkout = new Checkout({
	selectors: {
		wrapper: SELECTOR_WRAPPER,
		playerCount: SELECTOR_PLAYER_COUNT,
		paymentSection: SELECTOR_PAYMENT_SECTION,
		errorWrapper: SELECTOR_ERROR_WRAPPER
	}
});
export default checkout;
